import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=4dea7af6&"
import script from "./createTemplate.vue?vue&type=script&lang=ts&"
export * from "./createTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports